import { render } from "./MMEditAdvisor.vue?vue&type=template&id=1f25e364"
import script from "./MMEditAdvisor.vue?vue&type=script&lang=js"
export * from "./MMEditAdvisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__